module.exports = new __parcel__URL__("Business Status Update.60b38516.svg").toString();